import { Effect, Reducer } from 'umi';
import moment from 'moment';

const namespace = 'opinionFilter';

type stateType = any;

const customModel: {
  effects: {};
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    channel_social: ['9999'], // 默认 social channel，全选
    channel_comments: ['9999'], // 默认 comments channel，全选
    channel_news: ['9999'], // 默认 news channel，全选
    language: [], // 语言
    sentiment: [], // 情感
    social_media_by_keyword: [], // 关键词
    social_media_by_account: [], // 账号
    purpose: [], // 目标
    is_valid: [], // 是否有效
    keyword: [], // 关键词
    region: [], // 区域
    region_type: 'region', // 区域类型
    topic: [], // 话题
    start_time: moment().startOf('D').format('yyyy-MM-DD HH:mm:ss'),
    end_time: moment().endOf('D').format('yyyy-MM-DD HH:mm:ss'),
    date_type: 'daily', // 日期类型
    version: [], // 版本
    reviews_rating: [], // 评分
    monitor_scource: [], // 监控
    platform: [], // 平台
    version_time: '1', // 版本，好像暂时没什么用
    logic: 'and', // 逻辑
    // edition_unified_id: 'ufc454d9b1af70b40588e2a6fa4da4a8b', // 游戏版本
    // id_type: 'unified_id', // 游戏ID类型
    // entity_type: 'mobile', // 游戏类型
    // user_id: '203', // 用户ID
  },
  reducers: {
    save(state: stateType, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {},
};

export default customModel;
